(function () {
  var d = "alectrautilities";
  var t = "com";
  var targets = document.getElementsByClassName("secure-contact");
  for (var i = 0; i < targets.length; i++) {
    var u = targets[i].getAttribute("data-user") || "customerAODA";
    var full = u + "@" + d + "." + t;
    targets[i].innerHTML = 'Email: <a href="mailto:' + full + '">' + full + "</a>";
  }
})();
